import EventClass from "common/utils/ui/event-class";

// eslint-disable-next-line import/prefer-default-export
export class SearchDropdownFilter extends EventClass {
  static CATEGORY_CUSTOM_SHIRTS = "custom-shirts";

  static CATEGORY_BLANK_APPAREL = "blank-apparel";

  #props = {};

  #$activeButton = null;

  get #$hiddenInput() {
    return this.#$wrappedForm.querySelector("input[name='line_filter']");
  }

  get #$wrappedForm() {
    return this.#$activeButton.closest(this.#props.formSelector);
  }

  get #$buttons() {
    return this.#$wrappedForm.querySelectorAll(this.#props.eventSelector);
  }

  constructor(props) {
    super(props);
    this.#props = props;
  }

  static #getFilterValue(category) {
    if (category === SearchDropdownFilter.CATEGORY_CUSTOM_SHIRTS) {
      return "Customizable";
    }

    if (category === SearchDropdownFilter.CATEGORY_BLANK_APPAREL) {
      return "Blanks";
    }

    return null;
  }

  #connectHiddenInput(value) {
    if (this.#$hiddenInput) {
      this.#$hiddenInput.value = value;
      return;
    }

    const $hiddenInput = document.createElement("input");
    $hiddenInput.type = "hidden";
    $hiddenInput.name = "line_filter";
    $hiddenInput.value = value;
    this.#$wrappedForm.appendChild($hiddenInput);
  }

  #disconnectHiddenInput() {
    const $hiddenInput = this.#$hiddenInput;
    $hiddenInput?.remove();
  }

  event(event, $currentButton) {
    super.event(event, $currentButton);

    this.#$activeButton = $currentButton;

    this.#$buttons.forEach($button => {
      if ($button === $currentButton) {
        $button.dataset.active = $button.dataset.active !== "true";
      } else {
        $button.dataset.active = false;
      }
    });

    const isActive = $currentButton.dataset.active === "true";
    const filterValue = isActive
      ? SearchDropdownFilter.#getFilterValue($currentButton.dataset.category)
      : null;

    if (isActive && filterValue) {
      this.#connectHiddenInput(filterValue);
    } else {
      this.#disconnectHiddenInput();
    }
  }
}
